/** Safely turn processXslt output into HTML for dangerouslySetInnerHTML. */
export function toXsltHtml(preview: unknown): string {
  if (!preview) {
    return '';
  }
  if (typeof preview === 'string') {
    return preview;
  }
  if (typeof Node !== 'undefined' && preview instanceof Node) {
    try {
      return new XMLSerializer().serializeToString(preview);
    } catch {
      return '';
    }
  }
  return '';
}
